import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "text-truncate" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "btn btn-icon btn-secondary btn-circle btn-sm ms-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_KTCreateEventModal = _resolveComponent("KTCreateEventModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      viewName: "events",
      bulkDelete: _ctx.bulkDelete,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      activityTab: false,
      "bulk-delete-text-for-events": _ctx.bulkDeleteTextForEvents,
      onQueryUpdate: _ctx.queryUpdate,
      onCreateEvent: _ctx.createEvent,
      onTableRowClick: _ctx.tableRowClick,
      onSelectedItemsForDelete: _ctx.selectedItemsForDelete,
      permissions: _ctx.permissionModel
    }, {
      "cell-eventName": _withCtx(({ row: event }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(event.eventName), 1)
      ]),
      "cell-eventSubType": _withCtx(({ row: event }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(event &&
        event.eventSubType &&
        event.eventSubType
          .toLowerCase()
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase())), 1)
      ]),
      "cell-startDate": _withCtx(({ row: event }) => [
        _createElementVNode("span", {
          class: "text-truncate",
          title: _ctx.format.Date(event.startDate, 'MM-DD-YYYY hh:mm A')
        }, _toDisplayString(_ctx.format.Date(event.startDate)), 9, _hoisted_3)
      ]),
      "cell-endDate": _withCtx(({ row: event }) => [
        _createElementVNode("span", {
          class: "text-truncate",
          title: _ctx.format.Date(event.endDate, 'MM-DD-YYYY hh:mm A')
        }, _toDisplayString(_ctx.format.Date(event.endDate)), 9, _hoisted_4)
      ]),
      "cell-createdBy": _withCtx(({ row: event }) => [
        _createElementVNode("span", _hoisted_5, _toDisplayString(event.createdBy), 1)
      ]),
      "cell-status": _withCtx(({ row: event }) => [
        (event.status)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': event.status?.toLowerCase() === 'active',
          'badge badge-danger': event.status?.toLowerCase() !== 'active',
        }])
            }, _toDisplayString(_ctx.format.TitleCase(event.status?.toLowerCase())), 3))
          : _createCommentVNode("", true)
      ]),
      "cell-actions": _withCtx(({ row: event }) => [
        (_ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.editEvent(event)), ["stop"]),
              class: "btn btn-icon btn-primary btn-circle btn-sm"
            }, _hoisted_8, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (!event.lock && _ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = event;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_11, 8, _hoisted_9))
          : _createCommentVNode("", true),
        (event.lock)
          ? (_openBlock(), _createElementBlock("a", _hoisted_12, _hoisted_14))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "bulkDelete", "defaultFilter", "tableFilter", "bulk-delete-text-for-events", "onQueryUpdate", "onCreateEvent", "onTableRowClick", "onSelectedItemsForDelete", "permissions"]),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    _createVNode(_component_VZDeleteModal, {
      viewName: "events",
      showDialog: _ctx.showDeleteDialog,
      pageName: "event",
      selectedForAction: [_ctx.selectedForAction.webId],
      deleteText: _ctx.deleteAlertMessage(_ctx.selectedForAction),
      onOnDelete: _ctx.getEventsList,
      onClose: _ctx.refreshList
    }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onOnDelete", "onClose"]),
    (_ctx.isOpenModal)
      ? (_openBlock(), _createBlock(_component_KTCreateEventModal, {
          key: 0,
          singleEvent: _ctx.singleEvent,
          "events-list": _ctx.eventsList,
          onOnSubmit: _cache[2] || (_cache[2] = 
      () => {
        _ctx.refreshList();
        _ctx.isOpenModal = false;
      }
    ),
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpenModal = false))
        }, null, 8, ["singleEvent", "events-list"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "las la-business-time fs-3",
      viewName: "Events Activity Pulse",
      type: "1000,1800,2900"
    }, null, 8, ["refresh"])
  ], 64))
}